<script>
import * as LucideIcons from 'lucide-vue-next'

export default {
  name: 'LegacyHeader',
  props: {
    title: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
  computed: {
    iconComponent() {
      return this.icon ? LucideIcons[this.icon] : null
    },
  },
}
</script>

<template>
  <div class="flex items-center gap-3 mb-4">
    <component
      v-if="iconComponent"
      :is="iconComponent"
      class="w-7 h-7 text-foreground"
    />
    <h1 class="text-2xl font-semibold tracking-tight text-foreground">
      {{ title }}
    </h1>
    <slot />
  </div>
</template>
